import { useMemo } from 'react';

import Oops from '~/common/components/Oops';
import Spinner from '~/common/components/Spinner';
import useCalculationData from '~/pages/IncomeCalculator/Pages/GenericReviewBreakdown/useCalculationData';
import CalculationBreakdown from '~/pages/IncomeCalculator/Pages/ReviewBreakdown/QualifyingCalculation/QualifyingCalculationBreakdown';

type QualifyingIncomeBreakdownProps = {
  incomeIdentifier: any;
};

export default function QualifyingIncomeBreakdown({
  incomeIdentifier,
}: Readonly<QualifyingIncomeBreakdownProps>) {
  const { data, isFetching, isError } = useCalculationData(incomeIdentifier);

  const calculationId = data?.initialFormValues?.calculationId;
  const selectedResult = useMemo(() => {
    if (!calculationId) {
      return null;
    }

    return data.screenData.calculationData.find(
      (calc) => calc.calculationId === calculationId,
    );
  }, [calculationId, data?.screenData?.calculationData]);

  if (isError) {
    return <Oops />;
  }

  if (isFetching || !data) {
    return <Spinner />;
  }

  return <CalculationBreakdown selectedResult={selectedResult} hideAccordion />;
}
